const ArrowRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 9.75H12.6488L9.924 13.02C9.6585 13.338 9.702 13.8112 10.02 14.076C10.3387 14.3415 10.8113 14.298 11.0767 13.98L14.8267 9.48C14.856 9.44475 14.8702 9.4035 14.892 9.3645C14.91 9.333 14.9318 9.306 14.9452 9.2715C14.979 9.18525 14.9992 9.0945 14.9992 9.003C14.9992 9.00225 15 9.00075 15 9C15 8.99925 14.9992 8.99775 14.9992 8.997C14.9992 8.9055 14.979 8.81475 14.9452 8.7285C14.9318 8.694 14.91 8.667 14.892 8.6355C14.8702 8.5965 14.856 8.55525 14.8267 8.52L11.0767 4.02C10.9275 3.84225 10.7145 3.75 10.5 3.75C10.3305 3.75 10.1602 3.807 10.02 3.924C9.702 4.18875 9.6585 4.662 9.924 4.98L12.6488 8.25H3.75C3.336 8.25 3 8.586 3 9C3 9.414 3.336 9.75 3.75 9.75Z"
        fill="#FEF4F5"
      />
    </svg>
  );
};

export default ArrowRight;
